<ngx-loading-bar color="#ff4081" [includeSpinner]="false"></ngx-loading-bar>
<router-outlet></router-outlet>